import Admin from './admin/Admin'
import { initAuth0 } from './auth0'
import { ReactElement } from 'react'

const App = (): ReactElement => {
  const search = new URLSearchParams(location?.search)
  const organization = search?.get('organization') as string

  initAuth0(organization)

  return <Admin/>
}

export default App
